import _get from 'lodash/get';

function Ctrl($scope, $state, $stateParams, metaTagService) {
  $scope.loading = false;

  $scope.$watch('$parent.venue', function(venue) {
    if (!venue) return;

    metaTagService.set({
      title: `Upcoming Events at ${venue.name}`,
      description: `Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ${venue.name} with Tablelist.`,
      facebookImage: _get(venue, ['primaryImage', 'xlarge']),
      canonicalPath: `/v/${venue.seoPathname}/events`
    });
  });
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/venueEvents/venueEventsCtrl.js